import { ValidatorFn, AbstractControl } from '@angular/forms';
export function equalityValidator(originalPasswordControl: AbstractControl): ValidatorFn {
  return (passwordRepeatedControl: AbstractControl): { [s: string]: boolean } => {
    if (passwordRepeatedControl.value !== originalPasswordControl.value) {
      return { notEqual: true };
    }
  };
}
